// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export type FilterBy = 'all' | 'static' | 'dynamic';

const FilterButtons = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="subtitle1">Danh sách vai trò</Typography>
    </Box>
  );
};

export default FilterButtons;
